import RTE from '../components/RTE';
import FacetedFiltering from '../components/FacetedFiltering';

export default class StaticSearch {
  constructor(section) {
    this.el = section.el;
    this.rteEls = this.el.querySelectorAll('.rte');
    this.rtes = [];
    this.facetedFilters = new FacetedFiltering(this.el);

    for (let i = 0; i < this.rteEls.length; i++) {
      this.rtes.push(new RTE(this.rteEls[i]));
    }
  }

  onSectionUnload() {
    this.rtes.forEach(rte => rte.unload());
    this.facetedFilters.unload();
  }
}
